/**
 * @generated SignedSource<<fcc8e6d97b341dbb654dc65ea06318c9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedUserRecommendations_user$data = {
  readonly serviceId: string | null;
  readonly twoTowerModelItemRecommendations: {
    readonly recommendationIds: ReadonlyArray<string>;
  } | null;
  readonly " $fragmentType": "HpSharedUserRecommendations_user";
};
export type HpSharedUserRecommendations_user$key = {
  readonly " $data"?: HpSharedUserRecommendations_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedUserRecommendations_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedUserRecommendations_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserRecommendations",
      "kind": "LinkedField",
      "name": "twoTowerModelItemRecommendations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendationIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2968e2179b519026e16ade89857a5321";

export default node;
